document.addEventListener('DOMContentLoaded', function() {
  console.log("スライダー変換・機能追加処理を開始");

  var quotes = document.querySelectorAll('blockquote');
  
  quotes.forEach(function(quote) {
    if (quote.classList.contains('meirou-slider-wrapper')) return;

    var images = quote.querySelectorAll('img');
    var itemCount = images.length;
    
    // 画像がない場合はスキップ
    if (itemCount === 0) return;

    var isFullWidth = quote.querySelector('strong') !== null;
    
    // 1. ラッパーとトラックの作成
    var wrapper = document.createElement('div');
    wrapper.className = isFullWidth ? 'meirou-slider-wrapper' : 'meirou-slider-wrapper inner';
    
    var track = document.createElement('div');
    track.className = 'meirou-slider-track';
    
    // 2. 画像アイテムの移動
    images.forEach(function(img) {
      var item = document.createElement('div');
      item.className = 'meirou-slider-item';
      var inner = document.createElement('div');
      inner.className = 'meirou-slider-item-inner';
      inner.appendChild(img.cloneNode(true));
      item.appendChild(inner);
      track.appendChild(item);
    });
    
    // 3. ドットの作成
    var dotsContainer = document.createElement('div');
    dotsContainer.className = 'meirou-slider-dots';
    for(var i=0; i < itemCount; i++) {
        var dot = document.createElement('button');
        dot.className = 'meirou-dot';
        dotsContainer.appendChild(dot);
    }
    
    // 4. ボタンの作成
    var prevBtn = document.createElement('button');
    prevBtn.className = 'meirou-slider-btn prev is-hidden'; 
    prevBtn.innerHTML = '&lt;';
    var nextBtn = document.createElement('button');
    nextBtn.className = 'meirou-slider-btn next is-hidden'; 
    nextBtn.innerHTML = '&gt;';
    
    wrapper.appendChild(track);
    wrapper.appendChild(dotsContainer);
    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);
    quote.parentNode.replaceChild(wrapper, quote);
    
    // 5. 動作ロジック（UIの更新）
    var dots = dotsContainer.querySelectorAll('.meirou-dot');
    var items = track.querySelectorAll('.meirou-slider-item');
    var activeIndex = 0; 

    function updateUI() {
        var centerPosition = track.scrollLeft + (track.clientWidth / 2);
        items.forEach(function(item, index) {
            var itemCenter = item.offsetLeft + (item.offsetWidth / 2);
            if (Math.abs(centerPosition - itemCenter) < (item.offsetWidth / 2)) {
                activeIndex = index;
            }
        });

        prevBtn.classList.toggle('is-hidden', activeIndex === 0);
        nextBtn.classList.toggle('is-hidden', activeIndex === itemCount - 1);
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === activeIndex); });
    }

    track.addEventListener('scroll', updateUI);
    setTimeout(updateUI, 50);

    function snapToCurrent() {
        var targetItem = items[activeIndex];
        if (!targetItem) return;
        var scrollLeft = targetItem.offsetLeft - (track.clientWidth / 2) + (targetItem.offsetWidth / 2);
        track.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }

    // 6. 既存ボタンのクリックイベント
    prevBtn.addEventListener('click', function(e) {
        e.stopPropagation(); // トラックのクリック判定と重複しないようにする
        if (activeIndex > 0) { activeIndex--; snapToCurrent(); }
    });
    nextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (activeIndex < itemCount - 1) { activeIndex++; snapToCurrent(); }
    });
    dots.forEach(function(dot, index) {
        dot.addEventListener('click', function(e) { 
            e.stopPropagation();
            activeIndex = index; 
            snapToCurrent(); 
        });
    });

    // 7. マウスでのドラッグ ＆ スライド左右クリック判定
    var isDown = false;
    var startX;
    var startScrollLeft;
    var dragDistance = 0;

    track.addEventListener('mousedown', function(e) {
        isDown = true;
        dragDistance = 0;
        track.classList.add('is-dragging');
        startX = e.pageX - track.offsetLeft;
        startScrollLeft = track.scrollLeft;
    });

    function handleDragEnd() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        
        // ドラッグ（30px以上引っ張った）と判定された場合のみ強制スクロール
        if (Math.abs(dragDistance) >= 30) {
            if (dragDistance < -30 && activeIndex < itemCount - 1) {
                activeIndex++;
            } else if (dragDistance > 30 && activeIndex > 0) {
                activeIndex--;
            }
            snapToCurrent();
        }
    }

    track.addEventListener('mouseleave', handleDragEnd);
    track.addEventListener('mouseup', handleDragEnd);

    track.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        dragDistance = x - startX;
        track.scrollLeft = startScrollLeft - dragDistance;
    });

    // ★追加：スライドの左右半分をクリックした時の判定
    track.addEventListener('click', function(e) {
        // ドラッグ（スワイプ）操作の最後だった場合は、クリックとみなさない
        if (Math.abs(dragDistance) > 5) return;

        // クリックした位置のX座標を取得
        var rect = track.getBoundingClientRect();
        var clickX = e.clientX - rect.left;

        // トラックの幅の半分より「左」か「右」かで判定
        if (clickX < track.clientWidth / 2) {
            // 左半分をクリック
            if (activeIndex > 0) { 
                activeIndex--; 
                snapToCurrent(); 
            }
        } else {
            // 右半分をクリック
            if (activeIndex < itemCount - 1) { 
                activeIndex++; 
                snapToCurrent(); 
            }
        }
    });
  });
});